/**
 * Empty profile state.
 *
 * Shown on the dashboard when the owner has no profiles yet. A dedicated module
 * so the empty state is a first-class, testable piece rather than an inline
 * branch. Its job is to explain the next step and offer the single action.
 */

import { el, icon } from "../ui/dom.js";

/**
 * @param {import("../app/router.js").RouteContext} _context
 * @returns {HTMLElement}
 */
export function renderEmptyProfiles(_context) {
  return el("div", { class: "kin-empty" }, [
    icon("users"),
    el("h2", {}, ["No profiles yet"]),
    el("p", { class: "kin-prose" }, [
      "A profile holds the contacts someone can recover with a phrase and PIN. " +
        "Create your first one to get started.",
    ]),
    el("wa-button", { variant: "brand", href: "/profiles/new", dataset: { link: "" } }, [
      icon("plus"),
      "Create your first profile",
    ]),
  ]);
}
